<template>
  <v-select
      v-bind="$attrs"
      :items="items"
      dense
      @input="$emit('input', $event !== '' ? $event : null)"
      :label=label
      hide-details
  >
  </v-select>
</template>

<script>

export default {
  name: 'MslLifecycleSelect',
  inheritAttrs: false,
  props: {
    label: {default: null},
  },

  components: {},

  computed: {
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {
      items: [
        {value: 1, text: 'OK'},
        {value: 2, text: 'NOT_OK'},
        {value: 3, text: 'Critical'},
        {value: 4, text: 'Invalid'},
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
